import { render, staticRenderFns } from "./SatelliteGroup.vue?vue&type=template&id=5ed229de&scoped=true"
import script from "./SatelliteGroup.vue?vue&type=script&lang=js"
export * from "./SatelliteGroup.vue?vue&type=script&lang=js"
import style0 from "./SatelliteGroup.vue?vue&type=style&index=0&id=5ed229de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed229de",
  null
  
)

export default component.exports